import { ajaxRequest } from "../../Utils/Ajax/ajax";


export function fillTutorRightsModal(userId:number, instanceId:number, holder:JQuery){

    const url = '/instance/' + instanceId.toString() + '/tutor/' + userId.toString() + '/rights'

    const success = function (data){
        $("#tutor-settings-wrapper").html(data.html);
        $(".modal-tutor-name").html(data.name);
        $(".toggle-rights").bootstrapToggle('destroy')
        $(".toggle-rights").bootstrapToggle()
    }

    return ajaxRequest(url, success, {}, holder);

  }